"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maxWidth = exports.maxTextWidth = void 0;
const maxWidth = exports.maxWidth = 984;
const maxTextWidth = exports.maxTextWidth = 600;
